import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-trucks',
    template: '<router-outlet></router-outlet>',
})
export class TrucksComponent implements OnInit {

    constructor() {
    }

    ngOnInit(): void {
    }

}
